import { cookieStorage, sessionStorage } from '@/helpers/storage';

import { RENDERING_MODES } from '@/config/constants';
// src/auth/index.js
import { axios_legacy as axios, axios as axios_new_api } from '@/store/config';

// URL and endpoint constants
const LOGOUT_URL = 'logout';
const LOGOUT_URL_ONCALL = '/maintenance/logout';
const AUTH_TOKEN_KEY = 'abg.auth_token_ciam';
const AUTH_TOKEN_KEY_ON_CALL = 'abg.auth_token_oncall_ciam';
const SSO_QUERY_STRING_KEY = 'abg.sso_query_string_ciam';

// Använder cookie om man inte kör sso login
const storage = (() => {
  /**
   * Där av andra kollen
   */
  if (
    sessionStorage.getItem(AUTH_TOKEN_KEY)
  )
    return sessionStorage;

  return cookieStorage;
})();

var getToken = function () {
  if (storage.getItem(AUTH_TOKEN_KEY)) return storage.getItem(AUTH_TOKEN_KEY);

  return;
};

var getTokenOnCall = function () {
  if (storage.getItem(AUTH_TOKEN_KEY_ON_CALL)) return storage.getItem(AUTH_TOKEN_KEY_ON_CALL);

  return;
};

var clearAuthToken = function () {
  // //Remove the auth token
  // localStorage.removeItem(AUTH_TOKEN_KEY);
  // sessionStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY);
  cookieStorage.removeItem(AUTH_TOKEN_KEY);

  // //Remove the users name
  // localStorage.removeItem(SSO_QUERY_STRING_KEY);
  // sessionStorage.removeItem(SSO_QUERY_STRING_KEY);
  cookieStorage.removeItem(SSO_QUERY_STRING_KEY);
  sessionStorage.removeItem(SSO_QUERY_STRING_KEY);

  //Clear the headers
  axios.defaults.headers = {};
};

var clearAuthTokenOnCall = function () {
  // //Remove the auth token
  // localStorage.removeItem(AUTH_TOKEN_KEY);
  // sessionStorage.removeItem(AUTH_TOKEN_KEY);
  sessionStorage.removeItem(AUTH_TOKEN_KEY_ON_CALL);
  cookieStorage.removeItem(AUTH_TOKEN_KEY_ON_CALL);

  //Clear the headers
  axios.defaults.headers = {};
};


export default {
  getToken,
  getTokenOnCall,
  clearAuthTokenOnCall,
  loginWithUsernamePassword(creds) {
    try {
      return axios
        .post('login', {
          ...creds,
          //Token remain valid for for about 10 years (not counting leap years for one thing) or 30 minutes
          //ttl: creds.remember ? 2207520000 : 1800
          ttl: true ? 2207520000 : 1800,
        })
        .then((response) => {
          this.setAuthToken(response.data.access_token);
          return response.data;
        });
    } catch (error) {
      console.error(error.response.data);
      return false;
    }
  },

  loginWithHash(creds) {
    /**
     * Man bör inte kunna vara inloggad i en cookie och sedan inloggad i session
     * därför tas all data bort här innan den sätts igen nedan. då bara i session.
     */
    clearAuthToken();
    return axios
      .post('login/sso', {
        ...creds,
      })
      .then((response) => {
        this.setAuthToken(response.data.access_token);
      });
  },

  /**
   * Sätter authtoken i storage och ser till att den alltid skickas med.
   */
  setAuthToken(auth_token) {
    storage.setItem(AUTH_TOKEN_KEY, auth_token);

    //Set the authentication header
    axios.defaults.headers.Authorization = 'WebApi ' + auth_token;
  },

  setAuthTokenOnCall(auth_token) {
    storage.setItem(AUTH_TOKEN_KEY_ON_CALL, auth_token);

    //Set the authentication header
    axios.defaults.headers.Authorization = 'WebApi ' + auth_token;
  },

  loginWithBankID() {
    return axios.post('bankid/auth', {
      loginType: 'otherDevice',
      callbackUrl: 'http://localhost:8888/#/login/bankid',

      //Token remain valid for for about 10 years (not counting leap years for one thing) or 30 minutes
      //ttl: creds.remember ? 2207520000 : 1800
      ttl: true ? 2207520000 : 1800,
    });
  },

  fetchSSOQueryString() {
    return axios
      .get('/applicants/me/sso?url=/XpandWeb/Internet/Cm/StartLoggedOn.aspx')
      .then((response) => {
        const queryString = response.data
          // tar bort https://xpand.....
          .replace(/^(https?:\/\/)?(\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/gim, '')

          // tar bort resten. så bara querystringen är kvar
          .replace('/XpandWeb/Internet/Cm/StartLoggedOn.aspx', '')
          .replace('?', '');

        storage.setItem(SSO_QUERY_STRING_KEY, queryString);
        //localStorage.setItem(SSO_QUERY_STRING_KEY, queryString);

        return queryString;
      });
  },

  logout() {
    return axios
      .post(LOGOUT_URL, null, {
        validateStatus: (status) => {
          return (status >= 200 && status < 300) || status === 401;
        },
      })
      .then(clearAuthToken)
      .then(() => window.location.href = axios_new_api.defaults.baseURL + "/login/" + LOGOUT_URL).catch(err => console.error(err, "No redirect URL found in response headers"))
      .finally(() => {
        clearAuthToken();
      });
  },

  logoutOncall() {
    clearAuthTokenOnCall();
    return window.location.href = axios_new_api.defaults.baseURL + LOGOUT_URL_ONCALL;
  },

  //Returns if the storage contains a token
  async checkAuth() {
    const ok = !!getToken();
    return ok && await this.checkAuthApiV2();
  },

  async checkAuthOnCall() {
    const ok = true; //!!getTokenOnCall();
    return ok && await this.checkAuthOnCallApiV2();
  },


  async checkAuthApiV2() {
    return await axios_new_api.get('auth/check', {
      headers: {
        Authorization: 'WebApi ' + getToken(),
      },
    })
      .then((response) => {
        return response.status === 200;
      })
      .catch(() => {
        window.location.href = axios_new_api.defaults.baseURL + "/login";
        return false;
      });
  },

  async checkAuthOnCallApiV2() {
    return await axios_new_api.get('auth/check')
      .then((response) => {
        return response.status === 200;
      })
      .catch(() => {
        window.location.href = axios_new_api.defaults.baseURL + "/login/oncall";
        return false;
      });
  },
  /**
   * Kolla om användaren loggade in via SSO
   */
  userLoggedInWithSSO() {
    return !!sessionStorage.getItem(AUTH_TOKEN_KEY);
  },

  //Returns if the storage contains a token
  getSSOQueryString() {
    //return localStorage.getItem(SSO_QUERY_STRING_KEY) || sessionStorage.getItem(SSO_QUERY_STRING_KEY);

    return storage.getItem(SSO_QUERY_STRING_KEY);
  },

  refreshTokenCookie() {
    let token = storage.getItem(AUTH_TOKEN_KEY);
    if (token) {
      // storage.removeItem(AUTH_TOKEN_KEY);
      storage.setItem(AUTH_TOKEN_KEY, token);

      storage.setItem(SSO_QUERY_STRING_KEY, storage.getItem(SSO_QUERY_STRING_KEY));
    }
  },

  /**
   * Denna retunerade tidigare contactcode, eller personnumret.
   * Det är inte längre nödvändigt att hålla rätt på detta och istället skicka in 'me'.
   *
   * Jag behåller dock funktionen för att enklare kunna felsöka på ställen där jag inte kan testa om 'me' faktiskt fungerar. getNoteofinterests() och saveProfile() t.ex.
   */
  getUserId() {
    return 'me';
  },
};
